import { styled } from '@mui/material';

const StepIcon = styled('div')<{
  active: boolean;
  borderlineheight?: number | number[];
}>(({ theme, active, borderlineheight }) => ({
  '&:after': {
    position: 'absolute',
    top: 44,
    bottom: 0,
    content: '""',
    width: '2px',
    backgroundColor: theme.palette.divider,
    display: 'block',
    height: borderlineheight ?? 0,
  },
  position: 'relative',
  border: `1px solid ${
    active ? theme.palette.text.primary : theme.palette.text.secondary
  }`,
  borderRadius: '50%',
  height: 32,
  width: 32,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: active
    ? theme.palette.secondary.main
    : theme.palette.common.white,
}));

export default StepIcon;
